/* template.js */
(function anchorNavScript() {
	'use strict';

	const links = document.querySelectorAll('.article-link');
	if (!links.length) return;

	const setActive = (id) => {
		links.forEach((link) => {
			link.classList.toggle('active', link.dataset.target === id);
		});
	};

	links.forEach((link) => {
		link.addEventListener('click', () => {
			const id = link.dataset.target;
			if (id) setActive(id);
			// let the native anchor jump happen
		});
	});

	// initialize first link as active
	setActive(links[0].dataset.target);
})();

(() => {
	'use strict';

	document.addEventListener('DOMContentLoaded', () => {
		const nav = document.querySelector('.article-nav');

		if (nav) {
			nav.addEventListener('click', (e) => {
				if (e.target && e.target.matches('a.article-link')) {
					const expanded =
						nav.getAttribute('aria-expanded') === 'true';
					nav.setAttribute(
						'aria-expanded',
						expanded ? 'false' : 'true',
					);
				}
			});
		}
	});
})();
